import axios from "axios";
import { DataService } from "../../config/data/dataService";
import actions from "./actions";

const {
  getVendorListDataBegin,
  getVendorListDataSuccess,
  getVendorListDataErr,
  getVendorListDataReset,
  getExchangeProcessingDataBegin,
  getExchangeProcessingDataSuccess,
  getExchangeProcessingDataErr,
  getExchangeProcessingDataReset,
  checkAffordabilityBegin,
  checkAffordabilitySuccess,
  checkAffordabilityErr,
  checkAffordabilityReset,
  fileUploadBegin,
  fileUploadSuccess,
  fileUploadErr,
  resetFileUpload,
  submitExchangeProcessingDataBegin,
  submitExchangeProcessingDataSuccess,
  submitExchangeProcessingDataErr,
  getExchangeDashboardDataBegin,
  getExchangeDashboardDataSuccess,
  getExchangeDashboardDataErr,
  submitExchangeDataBegin,
  submitExchangeDataSuccess,
  submitExchangeDataErr,
  getSubmitExchangeReset,
  getExchangeHistoryDataBegin,
  getExchangeHistoryDataSuccess,
  getExchangeHistoryDataErr,
  getInhouseReferenceHistoryDataBegin,
  getInhouseReferenceHistoryDataSuccess,
  getInhouseReferenceHistoryDataErr,
  getExchangeViewDataBegin,
  getExchangeViewDataSuccess,
  getExchangeViewDataErr,
  getExchangeNewIMEIListBegin,
  getExchangeNewIMEIListSuccess,
  getExchangeNewIMEIListErr,
  getExchangeNewIMEIListReset,
  getSchemeListBegin,
  getSchemeListSuccess,
  getSchemeListErr,
  getSchemeListReset,
  getPaymentMethodBegin,
  getPaymentMethodSuccess,
  getPaymentMethodErr,
  getPaymentMethodReset,
  submitExchangePickupDataBegin,
  submitExchangePickupDataSuccess,
  submitExchangePickupDataErr,
  getExchangePickupDataReset,
  inhouseSubmitExchangePickupDataBegin,
  inhouseSubmitExchangePickupDataSuccess,
  inhouseSubmitExchangePickupDataErr,
  inhouseSubmitExchangePickupDataReset,
  postExchnageInhouseBegin,
  postExchnageInhouseSuccess,
  postExchnageInhouseErr,
  postExchnageInhouseReset,
} = actions;

export const getVendorListData = () => {
  return async (dispatch) => {
    try {
      dispatch(getVendorListDataBegin());
      const response = await DataService.post("/getVendorList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getVendorListDataSuccess(response.data.data));
      } else {
        dispatch(getVendorListDataErr(response.data));
      }
    } catch (error) {
      dispatch(getVendorListDataErr(error));
    }
  };
};

export const getExchangeProcessingData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeProcessingDataBegin());
      const response = await DataService.post("/getExchangeReference", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeProcessingDataSuccess(response.data.data));
      } else {
        dispatch(getExchangeProcessingDataErr(response.data));
      }
    } catch (error) {
      dispatch(getExchangeProcessingDataErr(error));
    }
  };
};

export const checkAffordability = (data) => {
  return async (dispatch) => {
    try {
      dispatch(checkAffordabilityBegin());
      const response = await DataService.post("/checkAffordability", data);

      if (response.status === 200 && response.data.status === true) {
        dispatch(checkAffordabilitySuccess(response.data.data));
      } else {
        dispatch(checkAffordabilityErr(response.data));
      }
    } catch (error) {
      dispatch(checkAffordabilityErr(error));
    }
  };
};
const uploadFile = (file, fileType, exchangeId) => {
  return async (dispatch) => {
    try {
      dispatch(fileUploadBegin(fileType));

      const formData = new FormData();
      const fileField =
        fileType === "video" ? "uploaded_video" : "uploaded_file";
      formData.append(fileField, file);
      formData.append("type", fileType);
      formData.append("exchange_id", exchangeId);

      const response = await axios.post(
        "/api/uploadExchangeProcessing",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (response.status === 200 && response.data.status === true) {
        dispatch(fileUploadSuccess(response.data.data, fileType));
      } else {
        dispatch(fileUploadErr(response.data.message, fileType));
      }
    } catch (error) {
      console.error(`${fileType} upload error:`, error);
      dispatch(fileUploadErr(error, fileType));
    }
  };
};

export const uploadVideo = (file, exchangeId) =>
  uploadFile(file, "video", exchangeId);
export const uploadPdf = (file, a, b) => {
  let fileType, exchangeId;
  if (b) {
    fileType = a;
    exchangeId = b;
  } else {
    fileType = "pdf";
    exchangeId = a;
  }

  return uploadFile(file, fileType, exchangeId);
};

export const submitExchangeProcessing = (data) => {
  return async (dispatch) => {
    try {
      dispatch(submitExchangeProcessingDataBegin());
      const formData = new FormData();

      formData.append("employee_id", data.employee_id || "");
      formData.append("brand", data.brand || "");
      formData.append("model", data.model || "");
      formData.append("imei", data.imei || "");
      formData.append("customer_name", data.customerName || "");
      formData.append("customer_mobile", data.customerMobile || "");
      formData.append("customer_email", data.customerEmail || "");
      formData.append("videoInfo", data.videoInfo || false);
      formData.append("certification", data.certification || false);

      if (data.video instanceof File) {
        formData.append("video", data.video);
      }

      if (Array.isArray(data.images)) {
        data.images.forEach((file, idx) => {
          if (file instanceof File) formData.append(`images[${idx}]`, file);
        });
      }

      const response = await axios.post(
        "/api/submitExchangeProcessing",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (response.status === 200 && response.data.status === true) {
        dispatch(submitExchangeProcessingDataSuccess(response.data.data));
      } else {
        dispatch(submitExchangeProcessingDataErr());
      }
    } catch (error) {
      console.error("submitExchangeProcessing error:", error);
      dispatch(submitExchangeProcessingDataErr(error));
    }
  };
};

export const getExchangeDashboardData = () => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeDashboardDataBegin());
      const response = await DataService.get("/getExchangeDashboard");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeDashboardDataSuccess(response.data.data));
      } else {
        dispatch(getExchangeDashboardDataErr(response.data));
      }
    } catch (error) {
      dispatch(getExchangeDashboardDataErr(error));
    }
  };
};

export const getExchangeHistoryData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeHistoryDataBegin());
      const response = await DataService.post("/getExchangeHistory", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeHistoryDataSuccess(response.data.data));
      } else {
        dispatch(getExchangeHistoryDataErr());
      }
    } catch (err) {
      dispatch(getExchangeHistoryDataErr(err));
    }
  };
};

export const getInhouseReferenceHistoryData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getInhouseReferenceHistoryDataBegin());
      const response = await DataService.post("/getInhouseReferenceHistory", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getInhouseReferenceHistoryDataSuccess(response.data.data));
      } else {
        dispatch(getInhouseReferenceHistoryDataErr(response.data));
      }
    } catch (err) {
      dispatch(getInhouseReferenceHistoryDataErr(err));
    }
  };
};

export const getExchangeViewDetails = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeViewDataBegin());
      const response = await DataService.post("/getExchangeDetails", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeViewDataSuccess(response.data.data));
      } else {
        dispatch(getExchangeViewDataErr());
      }
    } catch (err) {
      dispatch(getExchangeViewDataErr(err));
    }
  };
};

export const getExchangePickupData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(submitExchangePickupDataBegin());
      const response = await DataService.post(
        "/submitExchangePickupData",
        data,
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(submitExchangePickupDataSuccess(response.data.data));
      } else {
        dispatch(submitExchangePickupDataErr(response.data.message));
      }
    } catch (error) {
      dispatch(submitExchangePickupDataErr(error));
    }
  };
};

export const inhouseSubmitExchangePickupData = (data) => {
  return async (dispatch) => {
    try {
      dispatch(inhouseSubmitExchangePickupDataBegin());
      const response = await DataService.post(
        "/inhouseSubmitExchangePickupData",
        data,
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(inhouseSubmitExchangePickupDataSuccess(response.data.message));
      } else {
        dispatch(inhouseSubmitExchangePickupDataErr(response.data.message));
      }
    } catch (error) {
      dispatch(inhouseSubmitExchangePickupDataErr(error));
    }
  };
};

export const getExchangeNewIMEIList = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getExchangeNewIMEIListBegin());
      const response = await DataService.post("/getExchangeNewIMEIList", data);
      if (response.status === 200 && response.data.status === true) {
        dispatch(getExchangeNewIMEIListSuccess(response.data));
      } else {
        dispatch(getExchangeNewIMEIListErr(response));
      }
    } catch (error) {}
  };
};

export const submitExchange = (data) => {
  return async (dispatch) => {
    try {
      dispatch(submitExchangeDataBegin());
      const response = await DataService.post(
        "/submitExchange",
        { data },
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (response.status === 200 && response.data.status === true) {
        dispatch(submitExchangeDataSuccess(response.data.data));
      } else {
        dispatch(submitExchangeDataErr(response.data || "Error"));
      }
    } catch (error) {
      console.error("submitExchange error:", error);
      dispatch(submitExchangeDataErr(error));
    }
  };
};

export const getSchemeList = () => {
  return async (dispatch) => {
    try {
      dispatch(getSchemeListBegin());
      const response = await DataService.get("/getSchemeList");
      if (response.status === 200 && response.data.status === true) {
        dispatch(getSchemeListSuccess(response.data.data));
      } else {
        dispatch(getSchemeListErr());
      }
    } catch (err) {
      dispatch(getSchemeListErr(err));
    }
  };
};

export const getPaymentMethod = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getPaymentMethodBegin());
      const response = await DataService.post("/getPaymentMethod",{...data});

      if (response.status === 200 && response.data.status === true) {
        dispatch(getPaymentMethodSuccess(response.data.data));
      } else {
        dispatch(getPaymentMethodErr(response.data));
      }
    } catch (err) {
      dispatch(getPaymentMethodErr(err));
    }
  };
};

export const ResetPaymentMethod = () => {
  return async (dispatch) => {
    dispatch(getPaymentMethodReset());
  };
};

export const ResetSchemeList = () => {
  return async (dispatch) => {
    dispatch(getSchemeListReset());
  };
};


export const ResetVendorListData = () => {
  return async (dispatch) => {
    dispatch(getVendorListDataReset());
  };
};

export const ResetSubmitExchange = () => {
  return async (dispatch) => {
    dispatch(getSubmitExchangeReset());
  };
};

export const ResetFileUpload = () => {
  return async (dispatch) => {
    dispatch(resetFileUpload());
  };
};

export const ResetExchangeProcessingData = () => {
  return async (dispatch) => {
    dispatch(getExchangeProcessingDataReset());
  };
};

export const ResetCheckAffordability = () => {
  return async (dispatch) => {
    dispatch(checkAffordabilityReset());
  };
};

export const getExchangeNewIMEIListDataReset = () => {
  return async (dispatch) => {
    dispatch(getExchangeNewIMEIListReset());
  };
};

export const ResetgetExchangePickupData = () => {
  return async (dispatch) => {
    dispatch(getExchangePickupDataReset());
  };
};

export const ResetInhouseSubmitExchangePickupData = () => {
  return async (dispatch) => {
    dispatch(inhouseSubmitExchangePickupDataReset());
  };
};


export const postExchnageInhouse = (data) => {
  return async (dispatch) => {
    try {
      dispatch(postExchnageInhouseBegin());
      const response = await DataService.post(
        "/postInhouseExchange",
        data
      );
      if (response.status === 200 && response.data.status === true) {
        dispatch(postExchnageInhouseSuccess(response.data.data));
      } else {
        dispatch(postExchnageInhouseErr(response.data));
      }
    } catch (err) {
      dispatch(postExchnageInhouseErr(err));
    }
  };
};

export const postExchnageInhouseDataReset = () => {
  return async (dispatch) => {
    dispatch(postExchnageInhouseReset());
  };
};
